import { BaseError } from 'make-error';

/**
 * Thrown when attempting to retrieve cached data from a URL that was not configured to be cached.
 * (This error will never be trigger under normal operations).
 */
export class UnknownUrlError extends BaseError {
    constructor(message: string) {
        super(message);
    }
}

/**
 * Thrown when data has not yet been cached.
 */
export class NotCachedError extends BaseError {
    constructor(message: string) {
        super(message);
    }
}
